import css from "./FirstTimeEnterModal.module.css";
import logo from "../../assets/images/logo-dark-theme.png";
import checklistImage from "../../assets/images/academyImage_1.png";
import successImage from "../../assets/images/academyImage_2.png";
import mechanicImage from "../../assets/images/academyImage_3.png";

import { BsXLg } from "react-icons/bs";
import {
  FaCar,
  FaChartSimple,
  FaUserGroup,
  FaArrowTrendUp,
  FaGraduationCap,
  FaChevronRight,
  FaArrowRight,
} from "react-icons/fa6";

const ACADEMY_URL =
  "https://mechorbit.com/ua/academy?module=settings&chapter=1&step=1&lang=uk";

const benefits = [
  { icon: FaCar, text: "Менше рутини", color: "green" },
  { icon: FaChartSimple, text: "Більше контролю", color: "orange" },
  { icon: FaUserGroup, text: "Задоволені клієнти", color: "violet" },
  { icon: FaArrowTrendUp, text: "Більше прибутку", color: "blue" },
];

export default function FirstTimeEnterModal({ onClose }) {
  return (
    <div className={css.modalWrapper}>
      <img className={css.bgImage} src={mechanicImage} alt="" aria-hidden />

      <BsXLg className={css.closeIcon} onClick={onClose} />

      <div className={css.content}>
        <div className={css.header}>
          <img className={css.logo} src={logo} alt="CRMmech" />
          <h1 className={css.title}>
            Вітаємо в <span className={css.titleAccent}>CRMmech!</span>
          </h1>
          <p className={css.subtitle}>
            Відтепер ваше СТО працює простіше, а ви маєте більше контролю.
          </p>
        </div>

        <ul className={css.benefits}>
          {benefits.map(({ icon: Icon, text, color }) => (
            <li key={text} className={css.benefitCard}>
              <span className={`${css.benefitIcon} ${css[color]}`}>
                <Icon />
              </span>
              <span className={css.benefitText}>{text}</span>
            </li>
          ))}
        </ul>

        <a
          className={css.checklistCard}
          href={ACADEMY_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className={css.checklistIcon}>
            <FaGraduationCap />
          </span>
          <span className={css.checklistInfo}>
            <span className={css.checklistTitle}>Розпочніть з чекліста навчання</span>
            <span className={css.checklistText}>
              Покроковий список допоможе швидко налаштувати CRMmech та отримати
              максимум від системи.
            </span>
          </span>
          <img className={css.checklistImage} src={checklistImage} alt="" aria-hidden />
          <FaChevronRight className={css.checklistArrow} />
        </a>

        <div className={css.footer}>
          <img className={css.successImage} src={successImage} alt="Успіхів у розвитку!" />

          <div className={css.actions}>
            <a
              className={css.primaryBtn}
              href={ACADEMY_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Пройти чекліст <FaArrowRight />
            </a>
            <button type="button" className={css.skipBtn} onClick={onClose}>
              Перейти до CRMmech без навчання
            </button>
          </div>

          <div className={css.brand}>
            <span className={css.brandText}>Автосервіси ростуть разом з</span>
            <img className={css.brandLogo} src={logo} alt="CRMmech" />
          </div>
        </div>
      </div>
    </div>
  );
}
